import React, {Fragment} from 'react';
import { useAuth } from '../../Context/Context';
import { WavyLink } from "react-wavy-transitions";

import img1 from "../../Images/Servicios/Mantenimiento/1.png"
import img2 from "../../Images/Servicios/Mantenimiento/2.png"

import icon1 from "../../Images/Servicios/Iconos/12.png";
import icon2 from "../../Images/Servicios/Iconos/9.png";
import icon3 from "../../Images/Servicios/Iconos/11.png";
import icon4 from "../../Images/Servicios/Iconos/10.png";

import Portafolio from '../../Components/Portafolio';
import Efectos from '../../Components/Efectos';
import Contacto from '../../Components/Contacto';


const Mantenimiento = () => {
    const { direction, cambio } = useAuth();

    return(
        <Fragment>
            <div>
                <div className='fondo_servicio_7'>
                    <div >
                        <p className='sub_titulo_nv_4 cont_6' style={{color:"#ffffff"}}>
                            <span className='titulo_nv_2 line_height_3' style={{color:"#B5FCFD"}}>
                                Mantenimiento de equipos <br/>
                            </span>
                            Funcionalidad al 100%
                        </p>
                        <div className='cont_5'>
                            <p>
                                El mantenimiento de computo consiste en la limpieza de la máquina 
                                en el hardware del CPU para eliminar el polvo.
                            </p>
                            <p className='center'>
                                Agenda una cita y nosotros recogeremos todos los equipos
                                en tu domicilio para darle el mantenimiento necesario 
                                y programar la entrega de los mismos.
                            </p>
                        </div>
                    </div>
                    <div>
                        {window.screen.width <= 550 ? (
                            <Efectos activado={true}>
                                <img class="scroll-element js-scroll fade-in-bottom" src={img2} alt="" style={{width:"100%"}}/>
                            </Efectos>
                        ) : (
                            <Efectos activado={true}>
                                <img class="scroll-element js-scroll fade-in-bottom" src={img1} alt="" style={{width:"100%", maxWidth:"1485px"}}/>
                            </Efectos>
                        )}
                    </div>
                </div>
                

                <div className='cont_2'>
                    <p className='titulo_nv_1 center' style={{color:"#BF1F60"}}>
                        ¿Qué incluye?
                    </p>
                    <div style={{display:"flex", justifyContent:"space-evenly", flexWrap:"wrap", alignItems:"stretch"}}>
                        <div className='flex_1' style={{marginTop:"0"}}>
                            <div className='box_1' style={{marginTop:"0"}}>
                                <img src={icon1} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4 cont_movil_1' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Mantenimiento interno y externo
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Soporte, revisión, diagnostico e instalación de programas.
                                    </p>
                                </div>
                            </div>
                            <div className='box_1'>
                                <img src={icon4} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Limpieza física
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Realización de revisión y reparación que garanticen su buen 
                                        funcionamiento y fiabilidad.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='flex_1' style={{marginTop:"0"}}>
                            <div className='box_1' style={{marginTop:"0"}}>
                                <img src={icon2} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Mantenimiento del <br/>
                                        Software y Hardware
                                    </p>
                                </div>
                            </div>
                            <div className='box_1'>
                                <img src={icon3} alt="" className='icon_1'/>
                                <div>
                                    <p className='sub_titulo_nv_4' style={{color:"#6D1867", margin:"5px 0px"}}>
                                        Translado de equipo
                                    </p>
                                    <p className='contenedor_tablet' style={{margin:"0px"}}>
                                        Recogeremos tus los equipos en tu domicilio y después del mantenimiento 
                                        programar la entrega..
                                    </p>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>

                <div style={{display:"flex", justifyContent:"center"}}>
                    <WavyLink direction={direction ? "up" : "down"} to="/contacto" color={direction ? "#BF1F60" : "#2A79B0"}>
                        <p class="btn_1" onClick={cambio} style={{margin:"0px", color:"#fff",marginBottom:"50px"}}>
                            Cotiza tu proyecto
                        </p>
                    </WavyLink>
                    {/* <div className='btn_1' style={{marginBottom:"50px"}}>
                        <a href="/contacto" style={{color:"#fff"}}>
                            <p>
                                Cotiza tu proyecto
                            </p>
                        </a>
                    </div> */}
                </div>

                <Portafolio />
                <Contacto />
                
            </div>
        </Fragment>
    )
}

export default Mantenimiento;